<!--
 * @Author: 孙照
 * @LastEditTime: 2024-01-04 14:11:18
 * @Description: 场站信息 充电排行
 * @FilePath: \sheyang\src\module\overview\stationRank.vue
-->
<template>
  <div class="station-rank">
    <div class="header" @click="openRankModal">
      <pub-info-title :title="'场站信息'" />
    </div>
    <div class="leader_board">
      <div class="dot-nav">
        <div class="dot-row" v-for="(item, index) in rankTop5Data" :key="index">
          <div class="dot-item" v-if="item.todayPower"></div>
        </div>
      </div>
      <leader-board-echarts :rankingType="rankTop5Data" />
      <div class="leader_board_content">
        <div class="leader_board_info" v-for="(item, index) in rankTop5Data" :key="index">
          <p v-if="item.todayPower > 0">
            {{ item.rate }}%
          </p>
        </div>
      </div>
    </div>
    <!-- <div class="leader_board">
      <div class="dot-nav">
        <div class="dot-row" v-for="(item, index) in stationStatistics.rankingType" :key="index">
          <div class="dot-item" v-if="item.chargeCountRate"></div>
        </div>
      </div>
      <leader-board-echarts :rankingType="stationStatistics.rankingType" />
      <div class="leader_board_content">
        <div class="leader_board_info" v-for="(item, index) in stationStatistics.rankingType" :key="index">
          <p v-if="item.chargeCountRate > 0">
            {{ (item.chargeCountRate * 100).toFixed(2) }}%
          </p>
        </div>
      </div>
    </div> -->
    <!-- :rankData="stationStatistics.rankingType" -->
    <charging-rank-modal
      :visible="modalVisible"
      :rankData="totalList"
      @onChangeVisible="onChangeVisible"
    />
  </div>
</template>

<script>
import pubInfoTitle from '@/components/infoTitle/index.vue';
import leaderBoardEcharts from '@/components/leaderBoardEcharts/index.vue';
import chargingRankModal from '@/module/rankModal/index.vue';
import { getYesterdayOrTodayCharging } from '@/api/stationStatistics/index';

export default {
  name: 'stationRank',
  components: {
    pubInfoTitle,
    leaderBoardEcharts,
    chargingRankModal,
  },
  // props: {
  //   rankData: {
  //     type: Array,
  //     default: () => [],
  //   },
  //   totalList: {
  //     type: Array,
  //     default: () => [],
  //   },
  // },
  watch: {
    totalList: {
      handler (val) {
        this.rankTop5Data = val.slice(0, 5);
      },
      immediate: true,
    },
  },
  data () {
    return {
      modalVisible: false,
      rankTop5Data: [],
      totalList:[],
      leaderBoardList: ['1.39', '1.39'],
      stationStatistics: {
        chargingDegrees: 0,
        yesterdayDegrees: 0,
        rankingType: [],
      },
    };
  },
  mounted () {
    this.fetchYesterdayOrTodayChargingData();
  },
  methods: {
    // 昨日/今日充电量
    fetchYesterdayOrTodayChargingData (isShow=false) {
      getYesterdayOrTodayCharging().then((res) => {
        if (res.code === "200" && res.data) {
          const { rankingType, todayPowerLastHour } = res.data;
          let totalNum = Number(todayPowerLastHour);
          const newData = rankingType.map((item) => {
            return {
              ...item,
              rate: totalNum !== 0 ? ((item.todayPower / totalNum) * 100).toFixed(0) : "0",
            };
          });
          newData.sort((a, b) => b.todayPower - a.todayPower);
          this.totalList = newData;
          if(isShow){
            this.modalVisible = true;
          }
        }
      });
    },
    // 打开排行榜弹框
    openRankModal () {
      this.fetchYesterdayOrTodayChargingData(true)
    },
    onChangeVisible(flag) {
      this.modalVisible = flag;
    },
  },
};
</script>

<style lang="less" scoped>
.station-rank {
  width: 100%;
  .header {
    cursor: pointer;
  }
  .leader_board {
    width: 437px;
    height: 180px;
    margin-top: 18px;
    display: flex;

    .leader_board_content {

      .leader_board_info:first-child {
        margin-top: 5px;
      }

      .leader_board_info {
        font-size: 12px;
        color: #3AEBA8;
        height: 19px;
        line-height: 19px;
        margin-bottom: 13px;

        .leader_board_info:last-child {
          margin-bottom: 0;
        }
      }
    }

    .dot-nav {
      margin-right: 8px;

      .dot-item:first-child {
        margin-top: 10px;
      }

      .dot-row {
        height: 6px;
        margin-bottom: 26px;
      }

      .dot-item {
        display: block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-bottom: 20px;
        background: #96EBFF;
      }

      .dot-item:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
